import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type PatchQuoteComparisonViewPayload = {
  quoteComparisonViewId: string;
  clickedCriteria: string;
};

export const patchQuoteComparisonView = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (payload: PatchQuoteComparisonViewPayload): Promise<string> => {
      return fetchWithAuth<string>(
        "patchDossierQuoteComparisonView",
        dossierId,
        {
          requestOptions: {
            method: "PATCH",
            body: JSON.stringify(payload),
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
